export enum RequestStatus {
    NewRequest = 1,
    FetchingPayroll = 2,
    ImportReady = 3,
    RequestFailed = 4,
    FetchFailed = 5,
    Expired = 6,
}

// The dry-run validation outcome of a fetch, tracked separately from RequestStatus. Mirrors the backend
// RequestValidationStatus.
export enum ValidationStatus {
    NotValidated = 0,
    Validating = 1,
    Passed = 2,
    Failed = 3,
    CouldNotComplete = 4,
}

// The data types a payroll fetch stages, as they arrive in RequestTracker.StagingDetail.entityName. Mirrors the
// descriptions on the backend MonitoringEntityTypes and doubles as the display label.
export enum StagingEntityName {
    EmployeeStructure = 'Employee Structure',
    EmploymentRecords = 'Employment Records',
    EmployeeSalaries = 'Employee Salaries',
}

export enum ImportSource {
    Unspecified = 0,
    BEE = 1,
    EE = 2,
    CDM = 3,
    WSPATR = 4,
    EE_GroupImport = 5,
    Excel = 6,
    Payroll = 7
}

export enum ValidationFailureCategory {
    Unspecified = 0,
    Required = 1,
    InvalidValue = 2,
    InvalidDateRange = 3,
    NotFound = 4,
    Duplicate = 5
}